// @flow

import React from 'react';
import { CHECKBOX_INPUT_TYPE } from '@src/formik-utils/consts';

export const DIMENSIONS_FOR_WHICH_MULTI_SELECT_IS_ENABLED = ['connector_sku'];

export const TIERED_PRICING_CONFIRMATION_MODAL_CONFIG = {
  header: 'Committed Capacity Review Required',
  body: 'Changing this metric level discount may affect the effective discount for committed capacity. Please review your committed capacity configuration after saving. Non-admin rows will be auto-adjusted based on the new effective discount and admin rows will be untouched. However, a warning icon appears wherever the entered discount falls outside of the permitted range!',
  okText: 'Yes, I understand!!',
  cancelText: 'Cancel',
};

export const VBD_EDIT_CONFIRMATION_MODAL_CONFIG = {
  header: 'Change in System-Generated Discount',
  body: 'Once a system-generated discount is manually edited/deleted, automatic discount updates will no longer apply to this line item. This change cannot be undone on the estimate. If you wish to restore system-generated for this line item you will have to create a copy of the estimate and use the copy for future changes.',
  okText: 'Yes, I want to proceed',
  cancelText: 'No, take me back!',
};

export const VBD_ENABLE_FOR_RENEWALS_CONFIRMATION_MODAL_CONFIG = {
  header: 'Enable System-Generated Discounts for Renewals',
  body: (
    <>
      <p>
        <strong>Renewals:</strong> System-generated discounts are disabled by default for renewals.
        <br />
        <br />
        Enable them <strong>only when the NACV exceeds 20% of the current contract value. </strong>
        In cases where the NACV does not meet this criteria, system-generated discounts may not be
        approved by <strong>Pricing-911/DSM</strong> since existing discounts may continue to apply.
      </p>
    </>
  ),
  okText: 'Yes, I want to proceed',
  cancelText: 'No, revert my changes!',
};

export const APPLY_SYSTEM_GENERATED_DISCOUNTS_BACKEND_NAME = 'sg_discount_enabled';
export const APPLY_SYSTEM_GENERATED_DISCOUNTS_DISPLAY_NAME =
  'Apply System Generated Metric Level Discounts';
export const APPLY_SYSTEM_GENERATED_DISCOUNTS_CONFIG = {
  displayName: APPLY_SYSTEM_GENERATED_DISCOUNTS_DISPLAY_NAME,
  backendFieldName: APPLY_SYSTEM_GENERATED_DISCOUNTS_BACKEND_NAME,
  inputType: CHECKBOX_INPUT_TYPE,
};

export const APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_BACKEND_NAME = 'sg_global_discount_enabled';
export const APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_DISPLAY_NAME =
  'Apply System Generated Global Discounts';
export const APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_CONFIG = {
  displayName: APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_DISPLAY_NAME,
  backendFieldName: APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_BACKEND_NAME,
  inputType: CHECKBOX_INPUT_TYPE,
};
